module.exports = __webpack_public_path__ + "static/mwdj_0301-a1196cfbf647893ffdf15e65c22806ea.png";